import featureFlags from "../constants/featureFlags";
import DEFINE, { PATHS } from "./../constants/Define";

export default [
  {
    title: "FnB",
    tagSub: "fnb",
    exact: false,
    path: PATHS.FNB.path,
    show: true,
    icon: "faSuitcaseRolling",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.FNB,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
      {
        title: "outlets",
        group: "fnbOutlets",
        tagSub: "fnb",
        path: PATHS.FNB.OUTLET_MANAGER.LIST.path,
        exact: false,
        icon: "coffee",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_OUTLET,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.SYNC,
        ],
        children: [
          {
            title: "outlets",
            group: "fnbOutlets",
            tagSub: "fnb",
            path: PATHS.FNB.OUTLET_MANAGER.DETAIL.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_OUTLET,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.UPDATE,
              DEFINE.GENERAL.PERMISSION.SYNC,
            ],
          },
        ],
      },
      {
        title: "menu",
        group: "fnbMenu",
        tagSub: "fnb",
        path: PATHS.FNB.MENU_MANAGER.LIST.path,
        exact: false,
        icon: "coffee",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.SYNC,
        ],
        children: [
          {
            title: "Menu",
            group: "fnbMenu",
            tagSub: "fnb",
            path: PATHS.FNB.MENU_MANAGER.SUB_MENU.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.SYNC,
            ],
          },
          {
            title: "Menu",
            group: "fnbMenu",
            tagSub: "fnb",
            path: PATHS.FNB.MENU_MANAGER.SUB_MENU.DETAIL.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.UPDATE,
            ],
          },
        ],
      },
      {
        title: "menuItems",
        group: "fnbMenuItems",
        tagSub: "fnb",
        path: "/fnb/menu-items",
        exact: false,
        icon: "coffee",
        show: false,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_MENU_ITEM,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
        ],
      },
      {
        title: "fnbProduct",
        group: "fnbProduct",
        tagSub: "fnb",
        path: PATHS.FNB.PRODUCT?.LIST?.path,
        exact: false,
        icon: "coffee",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.SYNC,
        ],
      },
      {
        title: "condiment",
        group: "fnbCondiment",
        tagSub: "fnb",
        path: PATHS.FNB.CONDIMENT_MANAGER.LIST.path,
        exact: false,
        icon: "coffee",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.SYNC,
        ],
        children: [
          {
            title: "Condiment",
            group: "fnbCondiment",
            tagSub: "fnb",
            path: PATHS.FNB.CONDIMENT_MANAGER.SET_MENU.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.SYNC,
            ],
          },
          {
            title: "Condiment",
            group: "fnbCondiment",
            tagSub: "fnb",
            path: PATHS.FNB.CONDIMENT_MANAGER.DETAIL.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.UPDATE,
            ],
          },
        ],
      },
      {
        title: "option",
        group: "fnbOption",
        tagSub: "fnb",
        path: PATHS.FNB.OPTION_MANAGER.LIST.path,
        exact: false,
        icon: "coffee",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_OPTION,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.SYNC,
        ],
        children: [
          {
            title: "Option",
            group: "fnbOption",
            tagSub: "fnb",
            path: PATHS.FNB.OPTION_MANAGER.SET_ITEM.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_OPTION,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.SYNC,
            ],
          },
          {
            title: "Option",
            group: "fnbOption",
            tagSub: "fnb",
            path: PATHS.FNB.OPTION_MANAGER.DETAIL.path,
            exact: false,
            icon: "coffee",
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_OPTION,
            permissions: [
              DEFINE.GENERAL.PERMISSION.VIEW,
              DEFINE.GENERAL.PERMISSION.UPDATE,
            ],
          },
        ],
      },
    ],
  },
];
